import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { Order } from '@/mocks/orders';
import { statusColors } from '@/mocks/orders';

interface KanbanCardProps {
  order: Order;
}

export default function KanbanCard({ order }: KanbanCardProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: order.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  const paymentLabel = order.paymentType === 'kapida_odeme' ? 'Kapıda' : order.paymentType === 'havale' ? 'Havale' : 'K.Kartı';

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className="bg-white rounded-lg border border-stone-200 p-3 cursor-grab active:cursor-grabbing hover:border-stone-300 hover:shadow-sm transition-all select-none"
    >
      {/* Header */}
      <div className="flex items-start justify-between mb-2">
        <span className="text-xs font-mono font-semibold text-stone-800">{order.id}</span>
        <div className="flex items-center gap-1">
          {order.isUrgent && (
            <span className="text-[10px] bg-status-red/10 text-status-red px-1.5 py-0.5 rounded font-medium pulse-warning">ACİL</span>
          )}
          {order.note && (
            <span className="w-4 h-4 flex items-center justify-center text-status-yellow" title={order.note}>
              <i className="ri-sticky-note-line text-xs" />
            </span>
          )}
        </div>
      </div>

      {/* Customer */}
      <p className="text-sm font-semibold text-stone-800 mb-1 truncate">{order.customerName}</p>

      {/* Product */}
      <p className="text-xs text-stone-500 mb-2 truncate">{order.productName}</p>

      {/* Meta */}
      <div className="flex items-center justify-between text-xs text-stone-400">
        <span>{order.orderDate}</span>
        <span className={`${order.isLate ? 'text-status-red font-medium' : ''}`}>{order.estimatedDelivery}</span>
      </div>

      {/* Footer */}
      <div className="flex items-center justify-between mt-2 pt-2 border-t border-stone-100">
        <span className={`text-xs font-medium px-1.5 py-0.5 rounded ${
          order.paymentStatus === 'tahsil_edildi' ? 'bg-status-green/10 text-status-green' : 'bg-status-orange/10 text-status-orange'
        }`}>
          {paymentLabel}
        </span>
        <a
          href={`https://wa.me/${order.phone}`}
          target="_blank"
          rel="nofollow noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          className="w-6 h-6 flex items-center justify-center rounded-md bg-green-50 text-green-600 hover:bg-green-100 transition-colors"
        >
          <i className="ri-whatsapp-line text-xs" />
        </a>
      </div>
    </div>
  );
}